import React from 'react';
import _ from 'lodash';
import { Table, TableRow, TableRowColumn, TableBody, TableHeaderColumn, TableHeader } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

/** @type {Record<string, import('react').CSSProperties>} */
const styles = {
    headerCol: {
        borderLeft: '1px solid #DFDFDF',
        borderRight: '1px solid #DFDFDF',
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center',
    },
    actionsCol: {
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center',
    },
    topCol: {
        borderBottom: '0',
        paddingLeft: '7px',
        paddingRight: '7px',
    },
    bottomCol: {
        borderTop: '0',
        paddingLeft: '7px',
        paddingRight: '7px',
    },
    topRow: {
        borderBottom: '0',
    },
    bottomRow: {
        borderTop: '0',
    },
};

class CapacityV2 extends React.Component {
    constructor(props) {
        super(props);

        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
    }

    add() {
        const summary = _.cloneDeep(this.props.capacityV2.summary);

        summary.push({
            hold: {
                grain: undefined,
                bale: undefined,
                teu: undefined,
                feu: undefined,
            },
            tweenDeck: {
                grain: undefined,
                bale: undefined,
                teu: undefined,
                feu: undefined,
            },
        });

        this.props.changeField({ field: 'capacityV2.summary', value: summary });
    }

    remove(index) {
        const summary = _.cloneDeep(this.props.capacityV2.summary);
        summary.splice(index, 1);
        this.props.changeField({ field: 'capacityV2.summary', value: summary });
    }

    render() {
        const {
            grain, bale, teu, feu, summary, constant, 
        } = this.props.capacityV2;
        const {
            getError, changeField, confirmed, modifiedFields, underStyle, 
        } = this.props;

        const tableItem = (stateName1, stateName2, index) => (
            <NumberField
                name={`summary[${index}].${stateName1}.${stateName2}`}
                value={summary[index][stateName1] ? (summary[index][stateName1][stateName2] || '') : ''}
                floatNumber
                disabled={confirmed}
                errorText={getError(`capacityV2[summary][${index}][${stateName1}].${stateName2}`)}
                onChange={(e, value) => {
                    changeField({
                        field: `capacityV2.summary[${index}][${stateName1}].${stateName2}`,
                        value,
                    });
                    if (stateName1 === 'hold' || stateName1 === 'tweenDeck') {
                        const opposite = stateName1 === 'hold' ? 'tweenDeck' : 'hold';
                        if (summary[index][opposite] && summary[index][opposite][stateName2]) {
                            changeField({
                                field: `capacityV2.summary[${index}][compartment].${stateName2}`,
                                value: (parseInt(value, 10) + parseInt(summary[index][opposite][stateName2], 10)) || '',
                            });
                        }
                    }
                }}
                underlineStyle={
                    modifiedFields && modifiedFields
                        .includes(`capacityV2[summary][${index}][${stateName1}].${stateName2}`) ? underStyle : null
                }
            />
        );

        return (
            <React.Fragment>
                <div className="row">
                    <div className='col-xs-3'>
                        <NumberField
                            name='capacityV2.grain'
                            floatingLabelText='Grain, m3'
                            value={grain || ''}
                            disabled={confirmed}
                            errorText={getError('capacityV2.grain')}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: 'capacityV2.grain',
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('capacityV2.grain') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <NumberField
                            disabled={confirmed}
                            name='capacityV2.bale'
                            floatingLabelText='Bale, m3'
                            value={bale || ''}
                            errorText={getError('capacityV2.bale')}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: 'capacityV2.bale',
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('capacityV2.bale') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <NumberField
                            disabled={confirmed}
                            name='capacityV2.teu'
                            floatingLabelText='TEU'
                            value={teu || ''}
                            errorText={getError('capacityV2.teu')}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: 'capacityV2.teu',
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('capacityV2.teu') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <NumberField
                            disabled={confirmed}
                            name='capacityV2.feu'
                            floatingLabelText='FEU'
                            value={feu || ''}
                            fullWidth
                            floatNumber
                            errorText={getError('capacityV2.feu')}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'capacityV2.feu',
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('capacityV2.feu') ? underStyle : null}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12'>
                        <Table
                            selectable={false}
                            style={{ border: '1px solid #DFDFDF' }}
                        >
                            <TableHeader
                                adjustForCheckbox={false}
                                displaySelectAll={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn style={{ textAlign: 'center' }}>
                                        Hold
                                    </TableHeaderColumn>
                                    <TableHeaderColumn style={{ textAlign: 'center' }}>
                                        Tweendeck
                                    </TableHeaderColumn>
                                    <TableHeaderColumn style={{ textAlign: 'center' }}>
                                        Compartment<br />(Hold + Tween)
                                    </TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false}>
                                <TableRow>
                                    <TableRowColumn style={{ width: '80px' }} rowSpan={2} />
                                    <TableHeaderColumn style={styles.headerCol}>grain, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>bale, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>grain, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>bale, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>grain, m3</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>bale, m3</TableHeaderColumn>
                                    <TableRowColumn style={{ width: '80px' }} rowSpan={2} />
                                </TableRow>
                                <TableRow>
                                    <TableHeaderColumn style={styles.headerCol}>TEU</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>FEU</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>TEU</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>FEU</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>TEU</TableHeaderColumn>
                                    <TableHeaderColumn style={styles.headerCol}>FEU</TableHeaderColumn>
                                </TableRow>
                                {summary && summary.map((item, index) => (
                                    <React.Fragment key={`capacitySummary_${index}`}>
                                        <TableRow key={`1-${index}`} style={styles.topRow}>
                                            <TableRowColumn rowSpan={2}>{index + 1}</TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('hold', 'grain', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('hold', 'bale', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('tweenDeck', 'grain', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('tweenDeck', 'bale', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('compartment', 'grain', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.topCol}>
                                                {tableItem('compartment', 'bale', index)}
                                            </TableRowColumn>
                                            <TableRowColumn rowSpan={2} style={styles.actionsCol}>
                                                {index === 0 && (
                                                    <IconButton
                                                        disabled={confirmed}
                                                        onClick={() => this.add()}
                                                    >
                                                        <ContentAddIcon color='green' />
                                                    </IconButton>
                                                )}
                                                {index !== 0 && (
                                                    <IconButton onClick={() => this.remove(index)}>
                                                        <ContentRemoveIcon color='red' />
                                                    </IconButton>
                                                )}
                                            </TableRowColumn>
                                        </TableRow>
                                        <TableRow key={`2-${index}`} style={styles.bottomRow}>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('hold', 'teu', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('hold', 'feu', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('tweenDeck', 'teu', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('tweenDeck', 'feu', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('compartment', 'teu', index)}
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.bottomCol}>
                                                {tableItem('compartment', 'feu', index)}
                                            </TableRowColumn>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CapacityV2;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/CapacityV2.jsx